<template>
	<v-checkbox v-if="type === attributeType.boolean" v-model="localValue" v-bind="{ ...bindProps, ...inputProps }"/>
	<v-text-field v-else-if="type === attributeType.number" v-model.number="localValue" v-bind="{ ...bindProps, ...inputProps }"/>
	<v-text-field v-else-if="type === attributeType.string" v-model="localValue" v-bind="{ ...bindProps, ...inputProps }"/>
	<div
		v-else-if="[
			attributeType.multiChoice,
			attributeType.multiOptions,
			attributeType.yesNoMultiChoice,
		].includes(type)"
	>
		<v-text-field
			v-for="(item, i) in inputArray"
			:key="i"
			v-model="inputArray[i]"
			v-bind="{
				...bindProps,
				...inputProps,
				...(
					typeof multipleInputsBind === 'function'
					? multipleInputsBind(item, i)
					: multipleInputsBind
				),
			}"
			@input="val => {
				if (val && i === inputArray.length -1) inputArray.push(null)
				else if (!val && i > 0 && i === inputArray.length -1) inputArray.splice(i, 1);
				$emit('input', inputArray.filter(Boolean))
			}"
		/>
	</div>
	<div v-else-if="type === attributeType.multipleColor">
		<v-color-input
			v-for="(item, i) in colorArray"
			:key="item.id"
			v-model="colorArray[i].value"
			:clearable="i !== colorArray.length -1"
			:input-props="{
				...inputProps,
				...(
					typeof multipleInputsBind === 'function'
						? multipleInputsBind(item.value, i)
						: multipleInputsBind
				)
			}"
			v-bind="bindProps"
			@input="val => {
				if (val && i === colorArray.length -1) colorArray.push({ id: Date.now(), value: null });
				else if (!val && i > 0 && i === colorArray.length -1) colorArray.splice(i, 1);
				$emit('input', colorArray.filter(c => c.value).map(c => c.value))
			}"
			@click:clear="
				colorArray.splice(i, 1);
				$emit('input', colorArray.filter(c => c.value).map(c => c.value))
			"
		/>
	</div>
	<v-color-input
		v-else-if="type === attributeType.color"
		v-model="localValue"
		v-bind="bindProps"
		:input-props="inputProps"
	/>
</template>

<script>

import { attributeType } from '@/helpers/enums'
import VColorInput from './VColorInput.vue';
export default {
	name: 'BeeAttributeInput',
	props: {
		type: { type: Number, default: attributeType.string },
		label: { type: String },
		dense: { type: Boolean },
		readonly: { type: Boolean },
		outlined: { type: Boolean },
		'multiple-inputs-bind': { type: [Object, Function] },
		'hide-details': { type: [Boolean, String] },
		rules: { type: Array },
		inputProps: { type: Object, default: () => ({}) },
		value: { type: [String, Number, Boolean, Array, Object] }
	},
	components: { VColorInput },

	data: () => ({
		attributeType,

		inputArray: [null],
		colorArray: [{ id: Date.now(), value: null }],
	}),

	watch: {
		value: {
			handler(val) {				
				if (
					[
						attributeType.multiChoice,
						attributeType.multiOptions,
						attributeType.yesNoMultiChoice
					].includes(this.type) &&
					Array.isArray(val)
				) {
					this.inputArray = [...val, null];
				} else if (
					this.type === attributeType.multipleColor &&
					Array.isArray(val)
				) {
					val.forEach((color, i) => {
						if (this.colorArray[i]) this.colorArray[i].value = color;
						else this.colorArray.push({ id: Date.now() + i, value: color });
					});
					if (this.colorArray.length === val.length) {
						this.colorArray[this.colorArray.length - 1].value = null;
					}
				}
			},
			immediate: true,
		}
	},

	computed: {
		bindProps() {
			return {
				label: this.label,
				dense: this.dense,
				readonly: this.readonly,
				outlined: this.outlined,
				'hide-details': this.hideDetails,
				rules: this.rules,
				class: 'rounded-medium'
			}
		},

		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				if (
					[
						attributeType.multiChoice,
						attributeType.multiOptions,
						attributeType.yesNoMultiChoice
					].includes(this.type)
				) {
					this.$emit('input', this.inputArray);
				} else {
					this.$emit('input', val);
				}
			}
		}
	}
}
</script>

<style>

</style>